<script>
	import Permisos from './componentes/Permisos.svelte';
	
	import Input from './componentes/Forms/Input.svelte';
	import Modal from './components/Modal.svelte';
	import Titlesection from './components/Titlesection.svelte';
	import AnimationContainer from './components/AnimationContainer.svelte';
	import Navbar from './components/Navbar.svelte';
    import { push } from 'svelte-spa-router';
    import { urlapi, permisos, permisos_struct,permisos_title,miPermiso,iduser,login } from './stores/store';
    import { object2array, postData, isJson, mergeDeep } from './scripts';

    export let params = {}

    /* PERMISOS */
    let viewPage=false;

    if($login===false)
    {
        push('/login')
    } else if(
                $miPermiso.permisos.access===false
                || ($miPermiso.permisos.viewSelf===true && params.id!==$iduser)
                || ($miPermiso.permisos.edit!==true && parseInt(params.id)!==0)
                || ($miPermiso.permisos.insert!==true && parseInt(params.id)===0)
            ) {
        push('/sinpermiso')
    } else {
        viewPage=true;
    }
    /* FIN PERMISOS */


    // campos
    let id=false;
    let nombre='';
    let mispermisos=$permisos_struct;
    
    // status
    let disabled=false;
    let guardando=false;
    let insertando=false;

    let function_salir = function () { push('/permisos'); }

    let function_delete=function()
    {
        disabled=true;
        guardando=true;
        postData($urlapi, [{ 
            id,
            'cmd':'permisos_delete' 
        }])
        .then(data => {
            guardando=false;
            disabled=false;
            function_salir();
        });        
    }
    
    let save=async function()
    {
        disabled=true;
        guardando=true;

        const res = await postData($urlapi, [{ 
            id,
            nombre,
            insertando,
            'permisos':mispermisos,
            'cmd':'permisos_save' 
        }])
        .then(data => {
            guardando=false;
            disabled=false;
            function_salir();
        });
    }

    let load=function()
    {
        postData($urlapi, [{ 'id':id, 'cmd':'permisos_edit' }])
        .then(data => {
            if(data[0].result===false) {
                function_salir();
            } else {
                nombre=data[0].result.nombre
                if(isJson( data[0].result.permisos)===true) {
                    mispermisos=mergeDeep($permisos_struct, JSON.parse(data[0].result.permisos));
                } else {
                    mispermisos=$permisos_struct;                    
                }
            }
        });        
    }

    if(params.id!=0)
    {
        insertando=false;
        id=params.id;
        load();
    } else {
        insertando=true;
        id=0;
    }

    let handleKeydown=function(event) { 
        if(event.keyCode==13) save()
        if(event.keyCode==27) function_salir()
    }

</script>

<svelte:window on:keydown={handleKeydown}/>

{#if viewPage===true}
<Navbar />

<AnimationContainer marginTop=0>
    <Titlesection>
        <span slot="title"><i class="bi bi-shield-check me-1" />Roles de usuario
        <small class='badge bg-light text-success text-uppercase'>
        {#if insertando===true}
            Nuevo
        {:else}
            ID {id}
        {/if}
        </small>
        
        </span>
        <span slot="toolbar">
            <Modal textButton='Salir' classButton='btn-danger btn-sm' iconButton='bi-box-arrow-left' functionSi={function_salir} title='ADVERTENCIA' {disabled}>
                Esta seguro que desea <strong>Salir</strong>?<br/>
                Se perderán los cambios realizados
            </Modal>
            <button {disabled} class="btn btn-success" on:click={save}>
                {#if guardando===true}
                    <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                {/if}                
                <i class="bi bi-save me-1"></i>Guardar</button>
        </span>
    </Titlesection>

    <br/>
    <div class="row">
        <div class="col-12 col-md-6">

            <h6 class='fw-bold text-uppercase text-warning'>Datos</h6>

            <div><Input label='Nombre' bind:value={nombre} class='mb-2' {disabled}/></div>
            <br/><br/>
        </div>
        <div class="col-12 col-md-6">
            <Permisos bind:permisos={mispermisos} acciones={false}/>
            <br/><br/>
        </div>
    </div>
    <!-- <div class="row">
        <div class="col-12 col-md-6">
                <br/>
                <hr>
                
                <Modal textButton='Eliminar permiso' classButton='btn-danger btn-sm' iconButton='bi-trash' functionSi={function_delete} title='ADVERTENCIA' {disabled}>
                    Esta seguro que desea <strong>Eliminar</strong> los permisos?<br/>
                    Se perderán todos los datos de los permisos.
                </Modal>
            <br/><br/>   
        </div>
    </div> -->


</AnimationContainer>
{/if}